// @flow
import _ from 'lodash'
import React, { useMemo } from 'react'
import { View, Text, StyleSheet } from 'react-native'

import { ASTROLABE_VERSION } from '../../../../api'
import Row from '../../../../components/Row'
import themes from '../../../../modules/global/themes'
import Star from './Star'

type Props = {
  theme?: Object,
  branch: Object,
  version?: number,
  style?: Object,
}

const Palace = ({ theme, branch, version, style }: Props) => {
  const styles = useMemo(() => {
    const { palette, typography } = theme
    return {
      palace: {
        flex: 1,
        borderLeftWidth: 1,
        borderTopWidth: 1,
        borderColor: palette.border,
      },
      palaceWrapper: {
        flex: 1,
        paddingVertical: version > ASTROLABE_VERSION.PREVIEW ? 4 : 2,
        paddingHorizontal: 1,
        borderRadius: 3,
        maxHeight: '50%',
        alignItems: 'center',
        justifyContent: 'center',
      },
      palaceSelf: {
        backgroundColor: palette.self
      },
      palaceLife: {
        borderColor: palette.text.inverse,
        backgroundColor: palette.life,
      },
      palaceCommon: {
        borderWidth: 1,
        borderColor: palette.green,
      },
      palaceName: {
        textAlign: 'center',
        fontSize: version > ASTROLABE_VERSION.PREVIEW ? typography.starFontSize : typography.starFontSize - 2,
        color: palette.green,
      },
      palaceSelfName: {
        color: palette.text.inverse,
      },
      palaceLifeName: {
        color: palette.text.inverse,
        lineHeight: typography.starFontSize - 1,
      },
      stemBranch: {
        fontSize: version > ASTROLABE_VERSION.PREVIEW ? typography.minorStarFontSize : typography.minorStarFontSize - 2,
        lineHeight: version > ASTROLABE_VERSION.PREVIEW ? typography.minorStarFontSize + 2 : typography.minorStarFontSize - 3,
        color: palette.text.comment
      },
      decade: {
        textAlign: 'center',
        marginHorizontal: 1,
        backgroundColor: 'transparent',
        fontSize: typography.minorStarFontSize - 2,
      },
      ageYear: {
        fontSize: typography.minorStarFontSize - 5,
      },
    }
  }, [theme, version])

  const {
    mainStars,
    auxStars,
    minorStars,
    g12Stars,
    ll12Stars,
    palace,
    stemBranch,
    decade,
    ageYears,
  } = useMemo(() => {
    let mainStars,
      auxStars,
      minorStars,
      g12Stars,
      ll12Stars,
      palace,
      stemBranch,
      decade,
      ageYears
    if (branch) {
      mainStars = branch.mainStars
        .map(star => (
          <Star theme={theme} key={star.index} data={star} version={version} />
        ))
        .reverse()
      auxStars = _.sortBy(branch.auxStars, ['index'])
        .map(star => (
          <Star theme={theme} key={star.index} data={star} version={version} />
        ))
        .reverse()
      minorStars = branch.minorStars
        .map(star => (
          <Star theme={theme} key={star.index} data={star} version={version} />
        ))
        .reverse()
      g12Stars = branch.g12Stars.map(star => (
        <Star
          theme={theme}
          key={star.name + star.index}
          data={star}
          version={version}
        />
      ))
      ll12Stars = branch.ll12Stars.map(star => (
        <Star
          theme={theme}
          key={star.name + star.index}
          data={star}
          version={version}
        />
      ))

      const lifePalace = branch.isLifePalace ? (
        <View
          style={[
            styles.palaceWrapper,
            styles.palaceLife,
          ]}>
          <Text style={[
            styles.palaceName,
            styles.palaceLifeName,
          ]}>
            身宮
          </Text>
        </View>
      ) : null
      console.log('branch: ', branch)
      palace = (
        <View style={{ flex: 2 }}>
          {lifePalace}
          <View
            style={[
              styles.palaceWrapper,
              branch.palaceIndex === 0 ? styles.palaceSelf : styles.palaceCommon,
            ]}>
            <Text style={[styles.palaceName, branch.palaceIndex === 0 && styles.palaceSelfName]}>
              {branch ? branch.palaceName : null}
            </Text>
          </View>
        </View>
      )
      stemBranch = (
        <View style={{ flex: 1, alignItems: 'flex-end' }}>
          <Text style={styles.stemBranch}>
            {branch.stemName}
          </Text>
          <Text style={styles.stemBranch}>
            {branch.name}
          </Text>
        </View>
      )

      decade = branch.decade && (
        <Text style={[styles.decade]}>
          {branch.decade[0]} - {branch.decade[1]}
        </Text>
      )
      ageYears = branch.ageYears.map(age => (
        <Text key={age} style={[styles.decade, styles.ageYear]}>
          {age}
        </Text>
      ))
    }
    return {
      mainStars,
      auxStars,
      minorStars,
      g12Stars,
      ll12Stars,
      palace,
      stemBranch,
      decade,
      ageYears,
    }
  }, [branch])

  return (
    <View style={[styles.palace, style]}>
      <Row
        style={{ flex: 2, marginVertical: 0 }}
        alignHorizontal="flex-end"
        alignVertical="flex-start">
        {auxStars}
        {mainStars}
      </Row>
      {version > ASTROLABE_VERSION.SIMPLE && (
        <Row style={{ flex: 1, marginVertical: 0 }}>{minorStars}</Row>
      )}
      <View style={{ flex: 3 }}>
        {version > ASTROLABE_VERSION.PREVIEW && (
          <Row style={{ flex: 1, marginVertical: 0 }} alignHorizontal="center">
            {decade}
          </Row>
        )}
        <Row style={{ flex: 2, marginVertical: 0, paddingHorizontal: 4, alignItems: 'flex-end' }}>
          {version > ASTROLABE_VERSION.SIMPLE && g12Stars}
          {palace}
          {version > ASTROLABE_VERSION.SIMPLE && ll12Stars}
          {stemBranch}
        </Row>
        {version > ASTROLABE_VERSION.PREVIEW && (
          <Row style={{ flex: 1, marginVertical: 0 }} alignHorizontal="center">
            {ageYears}
          </Row>
        )}
      </View>
    </View>
  )
}
export default Palace
